export const SET_NOTIFICACOES = (state, payload) => {
  state.notificacoes = payload || []
}

export const SET_QTD_NOT_READ = (state, payload) => {
  state.qtdNotRead = payload || 0
}

export const SET_LOADING = (state, payload) => {
  state.loading = payload
}
